
<div *ngIf="addinfoGroups.length > 0">

    <form class="form" [formGroup]="addinfoForm" autocomplete="off">

        <div formArrayName="groups">

            <!-- <div *ngFor="let group of addinfoForm.get('groups')['controls']; let i = index;" [formGroupName]="i"> -->
                <div ngbAccordion *ngFor="let group of addinfoForm.get('groups')['controls']; let i = index"
                class="addinfo-accordion"
                [formGroupName]="i">

                    <div ngbAccordionItem [id]="'panel-' + i"
                        *ngIf="addinfoGroups[i]"
                        [collapsed]="!activeIds.includes('panel-' + i)">

                        <div ngbAccordionHeader>
                            <button ngbAccordionButton type="button" class="btn-accordion-title"
                                (click)="isClicked[i] = !isClicked[i]">
                                <div class="d-flex justify-content-between align-items-center w-100">
                                    <div class="addinfo-group-title">{{ addinfoGroups[i].attribute_group_name }}</div>
                                    <div class="addinfo-group-chevron" [ngClass]="{'clicked': isClicked[i], 'not-clicked': !isClicked[i]}"><i class="bi bi-chevron-down"></i></div>
                                </div>
                            </button>
                        </div>

                        <div ngbAccordionCollapse>
                          <div ngbAccordionBody>
                            <ng-template>
                              <ng-container *ngIf="addinfoGroups[i].attributes.length > 0">

                            <div class="row" formArrayName="attributes">
                                <!-- {
                                    'col-12': (addinfoGroups[i].attributes[j].attribute_id == '83d29149-0739-4cab-b203-4f65bfb72e81'),
                                    'col-6 attrs-fields': (addinfoGroups[i].attribute_group_id != 'fba74bc8-570d-4a52-8dd8-a81398c40718' && addinfoGroups[i].attribute_group_id != 'c45bb9b1-0111-4cda-b647-b05baf7dca9a' && addinfoGroups[i].attributes[j].attribute_id != '83d29149-0739-4cab-b203-4f65bfb72e81'),
                                    'col-2': (addinfoGroups[i].attribute_group_id == 'fba74bc8-570d-4a52-8dd8-a81398c40718' || addinfoGroups[i].attribute_group_id == 'c45bb9b1-0111-4cda-b647-b05baf7dca9a')
                                    }"  -->
                                <div [ngClass]="{
                                    'col-6 attrs-fields': (addinfoGroups[i].attribute_group_id != 'fba74bc8-570d-4a52-8dd8-a81398c40718' && addinfoGroups[i].attribute_group_id != 'c45bb9b1-0111-4cda-b647-b05baf7dca9a'),
                                    'col-2': (addinfoGroups[i].attribute_group_id == 'fba74bc8-570d-4a52-8dd8-a81398c40718' || addinfoGroups[i].attribute_group_id == 'c45bb9b1-0111-4cda-b647-b05baf7dca9a')
                                    }" 
                                    [attr.data-addinfo-group-id]="addinfoGroups[i].attribute_group_id"
                                    [attr.data-addinfo-attr-id]="addinfoGroups[i].attributes[j].attribute_id"
                                    *ngFor="let attr of group.get('attributes')['controls']; let j = index;">

                                    <div [formGroupName]="j">

                                        <!-- <div *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.combobox_multiple && addinfoGroups[i].attributes[j]?.attribute_id == '57368c7e-773b-4958-b7b1-145baba07868'">

                                            <label> 
                                                <span class="red-star" *ngIf="addinfoGroups[i].attributes[j].is_mandatory">*</span>
                                                {{ addinfoGroups[i].attributes[j].attribute_name }}
                                            </label>

                                            <div class="form-group integration">    

                                                <div *ngFor="let value of addinfoGroups[i].attributes[j].value_query">
                                                    
                                                   <span>{{ value.name }}</span> 
                                                        <div>
                                                            <label class="switch">
                                                                <input type="checkbox" (change)="getIntegrationValue(i, j, value.id)">
                                                                <span class="slider round"></span>
                                                            </label>
                                                        </div>
                                                </div>

                                            </div>


                                        </div> -->

                                        <!-- IF INPUT (string) -->
                                        <div *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.input && addinfoGroups[i].attributes[j].attribute_value_type == attrValueType.string">

                                            <div class="form-group">
                                                <label class="addinfo-label"> 
                                                    <!-- <span class="red-star" *ngIf="addinfoGroups[i].attributes[j].is_mandatory">*</span> -->
                                                    {{ addinfoGroups[i].attributes[j].attribute_name }}
                                                    <svg-icon *ngIf="addinfoGroups[i].attributes[j].is_mandatory" src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                                                </label>
                                                <input *ngIf="!addinfoGroups[i].attributes[j].translation"
                                                    class="form-control"
                                                    type="text" 
                                                    placeholder="Введите значение"
                                                    [formControl]="attr.controls.attribute_value"
                                                    [readonly]="!addinfoGroups[i].attributes[j].editable" />

                                                <ff-input-lang 
                                                    *ngIf="addinfoGroups[i].attributes[j].translation"
                                                    fieldId="name"
                                                    fieldName="name"
                                                    fieldType="text"
                                                    placeHolder="Укажите название значения на всех языках"
                                                    [readonly]="!addinfoGroups[i].attributes[j].editable"
                                                    [clearField]="ffInputLangParams.name.clearField"
                                                    [required]="ffInputLangParams.name.required"
                                                    [inputValue]="attr.controls.attribute_value.value"
                                                    (changeValue)="eventFnFF(i, j, $event)">
                                                </ff-input-lang>
                                            </div>
                                        </div>

                                        <!-- IF INPUT (number) -->
                                        <div *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.input && (addinfoGroups[i].attributes[j].attribute_value_type == attrValueType.numeric || addinfoGroups[i].attributes[j].attribute_value_type == attrValueType.integer)">

                                            <div class="form-group">
                                                <label class="addinfo-label"> 
                                                    <!-- <span class="red-star" *ngIf="addinfoGroups[i].attributes[j].is_mandatory">*</span> -->
                                                    {{ addinfoGroups[i].attributes[j].attribute_name }}
                                                    <svg-icon *ngIf="addinfoGroups[i].attributes[j].is_mandatory" src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                                                </label>
                                                <input 
                                                    class="form-control small-input"
                                                    type="number"
                                                    placeholder="Введите значение"
                                                    [formControl]="attr.controls.attribute_value"
                                                    [readonly]="!addinfoGroups[i].attributes[j].editable"
                                                    />
                                            </div>
                                        </div>

                                        <!-- IF INPUT (number) -->
                                        <!-- <div *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.checkbox">

                                            <div class="form-group checkbox-box">
                                                <label> 
                                                    <span class="red-star" *ngIf="addinfoGroups[i].attributes[j].is_mandatory">*</span>
                                                    {{ addinfoGroups[i].attributes[j].attribute_name }}:
                                                </label>
                                                <input 
                                                    class="form-control-checkbox"
                                                    type="checkbox"
                                                    [formControl]="attr.controls.attribute_value"
                                                    [readonly]="addinfoGroups[i].attributes[j].is_readonly" />
                                            </div>
                                        </div> -->

                                        <!-- IF TEXTAREA -->
                                        <div *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.textarea">

                                            <div class="form-group">
                                                <label class="addinfo-label"> 
                                                    <!-- <span class="red-star" *ngIf="addinfoGroups[i].attributes[j].is_mandatory">*</span> -->
                                                    {{ addinfoGroups[i].attributes[j].attribute_name }}
                                                    <svg-icon *ngIf="addinfoGroups[i].attributes[j].is_mandatory" src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                                                </label>
                                                <textarea *ngIf="!addinfoGroups[i].attributes[j].translation"
                                                    class="form-control"
                                                    [formControl]="attr.controls.attribute_value"
                                                    [readonly]="!addinfoGroups[i].attributes[j].editable"></textarea>
                                                    
                                                <app-ff-textarea-lang 
                                                    *ngIf="addinfoGroups[i].attributes[j].translation"
                                                    placeHolder="Укажите название значения на всех языках"
                                                    fieldId="name"
                                                    fieldName="name"
                                                    fieldType="text"
                                                    [readonly]="!addinfoGroups[i].attributes[j].editable"
                                                    [clearField]="ffInputLangParams.name.clearField"
                                                    [required]="ffInputLangParams.name.required"
                                                    [inputValue]="attr.controls.attribute_value.value"
                                                    (changeValue)="eventFnFF(i, j, $event)">
                                                </app-ff-textarea-lang>         
                                            </div>
                                        </div>

                                        <!-- IF COMBOBOX (select)-->
                                        <div *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.combobox">
                                            <div class="form-group">
                                                <label class="addinfo-label">
                                                    <!-- <span class="red-star" *ngIf="addinfoGroups[i].attributes[j].is_mandatory">*</span> -->
                                                    <svg-icon *ngIf="addinfoGroups[i].attributes[j].is_mandatory" src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                                                    {{ addinfoGroups[i].attributes[j].attribute_name }}
                                                </label>
                                                    <ng-select 
                                                        class="custom" 
                                                        clearAllText="{{ 'CLEAN' | translate }}" 
                                                        notFoundText="{{ 'NO_DATA' | translate }}"
                                                        placeholder="Выберите значение"
                                                        tooltipClass="clue-name" 
                                                        [closeDelay]="300"
                                                        bindLabel="name" 
                                                        bindValue="id" 
                                                        [formControl]="attr.controls.attribute_value"
                                                        [closeOnSelect]="true"
                                                        [readonly]="!addinfoGroups[i].attributes[j].editable"
                                                        [items]="addinfoGroups[i].attributes[j].value_query"
                                                        [dropdownPosition]="'bottom'"
                                                        appendTo="body"
                                                        >
                                                        <!-- <ng-option *ngFor="let value_query of addinfoGroups[i].attributes[j].value_query" [value]="value_query.id">{{ value_query.name }}</ng-option> -->
                                                    </ng-select>
                                            </div>
                                        </div>

                                        <!-- IF COMBOBOX_MULTIPLE (select)-->
                                        <div *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.combobox_multiple ">
                                            <div class="form-group">
                                                <label class="addinfo-label">
                                                    <!-- <span class="red-star" *ngIf="addinfoGroups[i].attributes[j].is_mandatory">*</span> -->
                                                    <svg-icon *ngIf="addinfoGroups[i].attributes[j].is_mandatory" src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                                                    {{ addinfoGroups[i].attributes[j].attribute_name }}
                                                </label>
                                                <ng-select 
                                                    class="custom" 
                                                    clearAllText="{{ 'CLEAN' | translate }}" 
                                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                                    placeholder="Выберите значение"
                                                    tooltipClass="clue-name" 
                                                    [closeDelay]="300"
                                                    bindLabel="name" 
                                                    bindValue="id" 
                                                    [formControl]="attr.controls.attribute_value"
                                                    [multiple]="true"
                                                    [closeOnSelect]="false"
                                                    [readonly]="!addinfoGroups[i].attributes[j].editable"
                                                    [items]="addinfoGroups[i].attributes[j].value_query"
                                                    [dropdownPosition]="'bottom'"
                                                    appendTo="body"
                                                    >
                                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                                        <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" />&nbsp;
                                                        <span>{{item.name}}</span>
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                        </div>

                                        <!-- IF DATE (***not error messages)-->
                                        <div *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.date">

                                            <div class="form-group">

                                                <label class="addinfo-label">
                                                    <!-- <span class="red-star" *ngIf="addinfoGroups[i].attributes[j].is_mandatory">*</span> -->
                                                    <svg-icon *ngIf="addinfoGroups[i].attributes[j].is_mandatory" src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                                                    {{ addinfoGroups[i].attributes[j].attribute_name }}
                                                </label>

                                                <div class="input-group">
                                                    <input class="form-control" [formControl]="attr.controls.attribute_value" [dayTemplate]="customDay" container="body" readonly="true" id="date" ngbDatepicker #dS="ngbDatepicker" [readonly]="!addinfoGroups[i].attributes[j].editable">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary calendar" (click)="dS.toggle()" type="button">
                                                            <i class="bi bi-calendar-event"></i>
                                                        </button>
                                                    </div>
                                                    <ng-template
                                                        #customDay 
                                                        let-date
                                                        let-currentMonth="currentMonth"
                                                        let-selected="selected"
                                                        let-disabled="disabled"
                                                        let-focused="focused">
                                                        <span
                                                            class="custom-day"
                                                            [class.focused]="focused"
                                                            [class.bg-primary]="selected"
                                                            [class.hidden]="date.month !== currentMonth"
                                                            [class.text-muted]="disabled">
                                                            {{ date.day }}
                                                        </span>
                                                    </ng-template>
                                                </div>

                                                <!-- <div class="input-group">
                                                    <input class="form-control" formControlName="valid_from" id="valid_from" ngbDatepicker #vFrom="ngbDatepicker">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-secondary calendar" (click)="vFrom.toggle()" type="button">
                                                            <i class="bi bi-calendar-event"></i>
                                                        </button>
                                                    </div>
                                                </div> -->

                                            </div>

                                        </div>

                                        <!-- IF FILE (***not error messages)-->

                                        <div class="attr-block-file" *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.file">

                                            <!-- Блок отображения иконок до загрузки файла -->
                                            <div class="upload-file-box" *ngIf="attr.get('files').value.length == 0">
                                              
                                                <!-- Кнопки для загрузки файла -->
                                                <div class="upload-file-btn">

                                                    <div class="block-no-photo">
                                                        <img src="/assets/images/icons/no-photo.svg" class="product-img_sze">
                                                    </div>

                                                    <div class="upload-file-label">
                                                        Загрузите {{ addinfoGroups[i].attributes[j].attribute_name }}
                                                        <svg-icon *ngIf="addinfoGroups[i].attributes[j].is_mandatory" src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                                                    </div>

                                                    <div class="upload-file-buttons">
                                                        <button class="btn btn-light" type="button" (click)="uploadFile(i, j)" *ngIf="addinfoGroups[i].attributes[j].editable" ngbTooltip="{{ 'UPLOAD_FILE' | translate }}" tooltipClass="clue-name" [closeDelay]="300">
                                                            <svg-icon class="" src="/assets/images/icons/upload.svg" [stretch]="true"></svg-icon>
                                                        </button>
                                                        <button class="btn btn-light" type="button" (click)="onUploadFileFromStorage(i, j)" *ngIf="addinfoGroups[i].attributes[j].editable" ngbTooltip="Загрузить файл из хранилища" tooltipClass="clue-name" [closeDelay]="300">
                                                            <svg-icon class="" src="/assets/images/icons/upload-from-storage.svg" [stretch]="true"></svg-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                
                                            </div>

                                            <!-- Блок отображения файла после прикрепления к продукту -->
                                            <div class="uploaded-file-block" *ngIf="attr.get('files').value.length > 0">

                                              <div *ngFor="let file of attr.get('files').value">

                                                <div class="icon-block" *ngIf="checkIconExt(file.name) == 'pdf' || checkIconExt(file.name) == 'docx' || checkIconExt(file.name) == 'doc' || checkIconExt(file.name) == 'xls' || checkIconExt(file.name) == 'xlsx'">

                                                  <div class="upload-file-icon">
                                                      <img class="product-img_size" src="/assets/images/file_icons/png/{{ checkIconExt(file.name) }}.png">
                                                  </div>

                                                </div>

                                                <div *ngIf="(checkIconExt(file.name) == 'jpg' || checkIconExt(file.name) == 'png' || checkIconExt(file.name) == 'jpeg')">

                                                    <div *ngIf="attr.get('files').value.length > 0">
                                                        <div class="block-photo" *ngFor="let image of attr.get('images').value">
                                                            <img class="product-img_size" src="{{ image }}">
                                                        </div>
                                                    </div>

                    
                                                </div>
                                              
                                              </div>

                                            </div>

                                            <!-- Кнопки действий с файлом -->
                                            <div *ngIf="attr.get('files').value.length > 0">

                                                <div class="upload-file-actions"  *ngFor="let file of attr.get('files').value">

                                                    <button class="btn btn-download" type="button" *ngIf="addinfoGroups[i].attributes[j].editable" ngbTooltip="{{ addinfoGroups[i].attributes[j].attribute_name }} {{ file.name}}" tooltipClass="clue-name" [closeDelay]="300">
                                                        <svg-icon class="" src="/assets/images/icons/about.svg"
                                                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                    </button>

                                                    <button class="btn btn-download" type="button" (click)="downloadFile(file)" *ngIf="addinfoGroups[i].attributes[j].editable" ngbTooltip="{{ 'DOWNLOAD_FILE' | translate }}" tooltipClass="clue-name" [closeDelay]="300">
                                                        <svg-icon class="" src="/assets/images/icons/download.svg"
                                                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                    </button>
                                                    <button class="btn btn-download" type="button" (click)="deleteValueFromFiles(i, j, file)" *ngIf="addinfoGroups[i].attributes[j].editable" ngbTooltip="Удалить файл" tooltipClass="clue-name" [closeDelay]="300">
                                                        <svg-icon src="/assets/images/icons/trash-can.svg"
                                                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                    </button>

                                                </div>
                                            
                                            </div>


                                            <!-- <div class="upload-file-btn" *ngIf="attr.get('files').value.length == 0">

                                                <button type="button" class="btn btn-primary btn-sm" (click)="uploadFile(i, j)" *ngIf="addinfoGroups[i].attributes[j].editable">
                                                    <i class="bi bi-download"></i> Загрузить файл
                                                </button>

                                                <button style="margin-left: 5px;" type="button" class="btn btn-primary btn-sm" (click)="onUploadFileFromStorage(i, j)" *ngIf="addinfoGroups[i].attributes[j].editable">
                                                    Загрузить файл из хранилища
                                                </button>
                                            </div>

                                            <div *ngIf="attr.get('files').value.length > 0">

                                                <table class="addinfo-table">
                                                    <tbody>
                                                        <tr class="addinfo-row" *ngFor="let file of attr.get('files').value">
                                                            <td class="addinfo-cell">{{ file.name }}</td>
                                                            <td class="addinfo-cell">
                                                                <button class="btn btn-light" type="button" (click)="downloadFile(file)" ngbTooltip="{{ 'DOWNLOAD_FILE' | translate }}">
                                                                    <i class="bi bi-download"></i>
                                                                </button>
                                                                <button class="btn btn-light" type="button" (click)="deleteValueFromFiles(i, j, file)">
                                                                    <i class="bi bi-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div> -->
                                        </div>

                                        <!-- IF TAG (***not error messages)-->
                                        <div *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.tags">

                                            <label class="addinfo-label">
                                                <!-- <span class="red-star" *ngIf="addinfoGroups[i].attributes[j].is_mandatory">*</span> -->
                                                {{ addinfoGroups[i].attributes[j].attribute_name }}
                                                <svg-icon *ngIf="addinfoGroups[i].attributes[j].is_mandatory" src="/assets/images/icons/info-circle.svg" [stretch]="true" ngbTooltip="Обязательное для заполнения" tooltipClass="clue-name" [closeDelay]="300"></svg-icon>
                                            </label>

                                            <div class="tags-table">

                                                <button type="button" class="btn btn-primary btn-sm" (click)="onCreateTags(i, j)" *ngIf="addinfoGroups[i].attributes[j].editable">

                                                    <div class="tag-btn">
                                                        <svg-icon src="/assets/images/icons/add.svg" [stretch]="true"
                                                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                        <span>{{ 'CERTIFICATE.ADD_EDIT_MARK' | translate }} </span>
                                                    </div>
                                                    
                                                </button>

                                                <div class="tags-table" *ngIf="attr.get('tags').value && attr.get('tags').value.length > 0">

                                                    <div class="tags-block" *ngFor="let tag of attr.get('tags').value">
    
                                                        <div class="tag-icon" *ngIf="tag.graphics_visible" [ngStyle]="getTagStyle(tag.tag_size_detail)">
                                                            <div [innerHTML]="tag.tagHtml" [color]="tag.color"></div>
                                                        </div>
    
                                                        <div class="tag-text" *ngIf="tag.text_visible" [ngStyle]="{'color': tag.font_color}">
                                                            {{tag.name}}
                                                        </div>
    
                                                        <button class="btn" type="button" (click)="deleteValueTags(i, j, tag)">
                                                            <!-- <i class="bi bi-trash"></i> -->
                                                            <svg-icon src="/assets/images/icons/close-circle.svg" [stretch]="true"
                                                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                        </button>
    
                                                    </div>
    
                                                    <!-- <table class="addinfo-table">
                                                        <thead>
                                                            <tr class="addinfo-header-row">
                                                                <th class="addinfo-header-cell">{{ 'CERTIFICATE.VISUAL_REPRES' | translate }}</th>
                                                                <th class="addinfo-header-cell">{{ 'ACTION' | translate }}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr class="addinfo-row" *ngFor="let tag of attr.get('tags').value">
                                                                <td class="addinfo-cell">
                                                                    <div class="tag-box">
                                                                        <div class="tag-box">
                                                                            <div *ngIf="tag.graphics_visible" [ngStyle]="getTagStyle(tag.tag_size_detail)">
                                                                                <div [innerHTML]="tag.tagHtml" [color]="tag.color"></div>
                                                                            </div>
                                                                            <div *ngIf="tag.text_visible" [ngStyle]="{'color': tag.font_color}">
                                                                                {{tag.name}}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td class="addinfo-cell">
                                                                    <button class="btn btn-light" type="button" (click)="deleteValueTags(i, j, tag)">
                                                                        <i class="bi bi-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table> -->
    
                                                </div>
                                            </div>

                                           

                                        </div>

                                        <!-- IF CERTIFICATE-->
                                        <div  class="attr-block-certificate"  *ngIf="addinfoGroups[i].attributes[j]?.attribute_type == attrType.certificate">

                                            <div class="upload-certificate-box" *ngIf="!attr.get('certificate').value && addinfoGroups[i].attributes[j].editable">

                                                <!-- Блок отображения иконок до загрузки сертификата -->
                                                <div class="upload-file-btn-certificate">

                                                    <!-- <div class="block-no-photo">
                                                        <img src="/assets/images/icons/no-photo.svg" class="product-img_sze">
                                                    </div> -->
    
                                                    <div class="upload-certificate-label">
                                                        Прекрепить {{ addinfoGroups[i].attributes[j].attribute_name }}
                                                    </div>
    
                                                    <div class="upload-certificate-buttons">
                                                        <button class="btn btn-light" type="button" (click)="openDialogCreateCert(i, j, attr.get('attribute_id').value)" *ngIf="addinfoGroups[i].attributes[j].editable" ngbTooltip="Загрузить сертификат" tooltipClass="clue-name" [closeDelay]="300">
                                                            <svg-icon class="" src="/assets/images/icons/upload.svg" [stretch]="true"></svg-icon>
                                                        </button>
                                                    </div>
    
                                                </div>

                                            </div>

                                            <!-- Блок отображения сертификата после прикрепления к продукту -->
                                            <div class="uploaded-file-block-certificate" *ngIf="attr.get('certificate').value">
                                    
                                               <div *ngFor="let file of attr.get('certificate').value.file">

                                                <div class="icon-block-certificate"  *ngIf="checkIconExt(file.name) == 'pdf' || checkIconExt(file.name) == 'docx' || checkIconExt(file.name) == 'doc' || checkIconExt(file.name) == 'xls' || checkIconExt(file.name) == 'xlsx'">

                                                   <div class="upload-file-icon-certificate">
                                                       <img class="product-img_size" src="/assets/images/file_icons/png/{{ checkIconExt(file.name) }}.png">
                                                   </div>
                                                   
                                                </div>

                                                <div *ngIf="(checkIconExt(file.name) == 'jpg' || checkIconExt(file.name) == 'png' || checkIconExt(file.name) == 'jpeg')">

                                                    <div class="certificate-block-photo" *ngFor="let image of attr.get('images').value">
                                                        <img class="product-img_size" src="{{ image }}">
                                                    </div>

                                                </div>
                                               
                                            </div>
                                               
                                               
                                               <!-- <table class="addinfo-table">
                                                   <thead>
                                                       <tr class="addinfo-header-row">
                                                           <th class="addinfo-header-cell">{{ 'NAME' | translate }}</th>
                                                           <th class="addinfo-header-cell cert-valid-date">{{ 'VALID_FORM' | translate }}</th>
                                                           <th class="addinfo-header-cell cert-valid-date">{{ 'VALID_UNTIL' | translate }}</th>
                                                           <th class="addinfo-header-cell">{{ 'ACTION' | translate }}</th>
                                                       </tr>
                                                   </thead>
                                                   <tbody>
                                                       <tr class="addinfo-row">
                                                           <td class="addinfo-cell">
                                                               <span *ngIf="attr.get('certificate').value.file.length > 0">
                                                                   {{ attr.get('certificate').value.file[0].name }}
                                                               </span>
                                                           </td>
                                                           <td class="addinfo-cell cert-valid-date">
                                                               {{ attr.get('certificate').value.valid_from | date: 'dd.MM.yyyy HH:mm' }}
                                                           </td>
                                                           <td class="addinfo-cell cert-valid-date">
                                                               {{ attr.get('certificate').value.valid_to | date: 'dd.MM.yyyy HH:mm' }}
                                                           </td>
                                                           <td class="addinfo-cell">
                                                               <button type="button" class="btn btn-light" (click)="downloadFile(attr.get('certificate').value.file[0])" matTooltip="{{ 'DOWNLOAD_FILE' | translate }}">
                                                                   <i class="bi bi-download"></i>
                                                               </button>
                                                               <button type="button" class="btn btn-light" (click)="deleteValueForCert(i, j, attr)">
                                                                   <i class="bi bi-trash"></i>
                                                               </button>
                                                           </td>
                                                       </tr>
                                                   </tbody>
                                               </table> -->
                                            </div>
                                               

                                            <!-- Кнопки действий с сертификатом -->
                                            <div class="upload-file-actions" *ngIf="attr.get('certificate').value">
    
                                                <button class="btn btn-download" type="button" *ngIf="addinfoGroups[i].attributes[j].editable" ngbTooltip="{{ addinfoGroups[i].attributes[j].attribute_name }} {{ attr.get('certificate').value.file[0].name }}" tooltipClass="clue-name" [closeDelay]="300">
                                                    <svg-icon class="" src="/assets/images/icons/about.svg"
                                                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                </button>

                                                <button class="btn btn-download" type="button" (click)="downloadFile(attr.get('certificate').value.file[0])" *ngIf="addinfoGroups[i].attributes[j].editable" ngbTooltip="{{ 'DOWNLOAD_FILE' | translate }}" tooltipClass="clue-name" [closeDelay]="300">
                                                    <svg-icon class="" src="/assets/images/icons/download.svg"
                                                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                </button>
                                                <button class="btn btn-download" type="button" (click)="deleteValueForCert(i, j, attr)" *ngIf="addinfoGroups[i].attributes[j].editable" ngbTooltip="Удалить файл" tooltipClass="clue-name" [closeDelay]="300">
                                                    <svg-icon src="/assets/images/icons/trash-can.svg"
                                                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                                </button>

                                            </div>
                 
                                        </div>
                                    </div>
                                </div>
                            
                            </div>
                              </ng-container>
                            </ng-template>
                          </div>
                        </div>
                    </div>
                </div>
            <!-- </div> -->
        </div>
    </form>
</div>